export const RESIZE_DEBOUNCE_MS = 100;
export const MORE_BUTTON_WIDTH_RESERVE = 40;
export const MIN_GAP = 12;
export const MAX_GAP = 24;

// Hidden measurement container for useOverflowCount — renders the full item set (and, optionally,
// the overflow trigger) off-screen so the hook can read each child's natural offsetWidth. Shared by
// every consumer of the hook so the measurement contract stays defined in one place.
export const measureContainerStyles = {
  position: 'absolute',
  visibility: 'hidden',
  height: 0,
  overflow: 'hidden',
  display: 'flex',
  flexWrap: 'nowrap',
  gap: 0,
  pointerEvents: 'none',
};
